import API from '@/api/index';
import moment from 'moment';
import * as DateTimeUtil from '@/utils/datetime';

const history = {
  state: {
    isViewHistory: false,
    isViewHistoryDetail: false,
    tripReporting: [],
    historyFromDate: moment().startOf('day'),
    historyToDate: moment().endOf('day'),
  },

  mutations: {
    SET_VIEW_HISTORY_STATE: (state, isView) => {
      state.isViewHistory = isView;
      if (!isView) {
        state.tripReporting = [];
      }
    },
    SET_VIEW_HISTORY_DETAIL_STATE: (state, isView) => {
      state.isViewHistoryDetail = isView;
    },
    SET_TRIP_REPORTING: (state, reporting) => {
      state.tripReporting = reporting;
    },
    SET_HISTORY_FROM_DATE: (state, date) => {
      state.historyFromDate = date;
    },
    SET_HISTORY_TO_DATE: (state, date) => {
      state.historyToDate = date;
    },
  },

  actions: {
    getTripReporting ({ commit, state, rootState }) {

      let params = {
        vehicleIds: [rootState.vehicle.selectedVehicle.id],
        fromTime: DateTimeUtil.convertDateTimeToSecond2010(
          state.historyFromDate
        ),
        toTime: DateTimeUtil.convertDateTimeToSecond2010(state.historyToDate)
      };

      return new Promise((resolve, reject) => {
        API.reporting.getTripReporting(params).then(response => {
          let result = response.data;
          if (!result.code && result.data.length > 0) {
            commit('SET_TRIP_REPORTING', result.data[0].trip);
            resolve(result.data.trip);
          } else {
            commit('SET_TRIP_REPORTING', []);
            reject(result);
          }
        }).catch(error => {
          commit('SET_TRIP_REPORTING', []);
          reject(error);
        });
      });
    },
  }
};

export default history;


// WEBPACK FOOTER //
// ./src/store/modules/history.js